/**
 * 지정된 규칙에 따라서, 글자 크기를 조정하는 파이프
 *
 * (1) 한자인 경우 80% 크기로 줄임.
 * 반대말 표시는 200% 크기로 키움.
 */
import { Pipe, PipeTransform } from '@angular/core';


/** 한 글자 이상의 한자를 찾는 정규식 */
// const regexHanja = new RegExp('[\u4E00-\u9FCC\u2e80-\u2fd5\u3190-\u319f\u3400-\u4DBF\uF900-\uFAAD\u{20000}-\u{2A6DF}]+', 'gu');
const regexSkipHtml = /<[^>]*>|[\u4E00-\u9FCC\u2e80-\u2fd5\u3190-\u319f\u3400-\u4DBF\uF900-\uFAAD\u{20000}-\u{2A6DF}]+/gu;

@Pipe({
  name: 'resize'
})
export class ResizePipe implements PipeTransform {

  transform(content: string | null): string | null {
    if (content) {
      content = content.replace(regexSkipHtml, (match) => {
        // HTML 태그는 그대로 반환
        if (match.startsWith('<')) {
          return match;
        }
        // 한자는 <span> 태그로 감싸 반환
        return `<span class="hanja-size">${match}</span>`;
      });

      content = content.split('↔').join('<img src="assets/img/ic_arrow_left_right.svg" class="arrow-symbol" alt="반대말">');

      content = content.split('→').join('<img src="assets/img/ic_arrow_right2.svg" class="arrow-symbol" alt="잘못된 표현">');

      content = content.split('←').join('<img src="assets/img/ic_arrow_left2.svg" class="arrow-symbol" alt="왼쪽 화살표">');
    }
    return content;
  }

}
